var Dropzone = require('dropzone');

// Disable auto discover for all elements:
Dropzone.autoDiscover = false;

module.exports = Dropzone;